import { useState, useCallback } from "react";

import {
  updateNoomIntakeStatus,
  type NoomIntakeCompletionType,
} from "../modules/intake/updateNoomIntakeStatus";

import { useAuthCredentials } from "./useAuthCredentials";

const GENERIC_ERROR =
  "Something went wrong. Please try again or contact support.";

export const useUpdateNoomIntakeStatus = (): {
  completeIntake: (intakeType: NoomIntakeCompletionType) => Promise<boolean>;
  loading: boolean;
  error: string | null;
} => {
  const { accessCode, accessToken } = useAuthCredentials();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const completeIntake = useCallback(
    async (intakeType: NoomIntakeCompletionType) => {
      if (!accessCode || !accessToken) {
        setError("User not authenticated");
        return false;
      }

      try {
        setLoading(true);
        setError(null);
        await updateNoomIntakeStatus(accessCode, accessToken, intakeType);
        return true;
      } catch {
        setError(GENERIC_ERROR);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [accessCode, accessToken]
  );

  return { completeIntake, loading, error };
};
